<template>
	<dv-border-box-12>
		<div class="box">
			<div class="box_title">知识产权行政执法</div>
			<div class="protect">
				<div class="protect_left">
					<div id="caseChart1" :style="{ width: '100%', height: '100%' }"></div>
				</div>
				<div class="protect_right">
					<div id="caseChart2" :style="{ width: '100%', height: '100%' }"></div>
				</div>
			</div>
		</div>
	</dv-border-box-12>
</template>

<script>
	export default {
		data() {
			return {}
		},
		mounted() {
			
		},
		methods:{
			getData(list1,list2){
				this.drowChart3(list1);
				for(var i in list2){
					list2[i].name = list2[i].city.split('市')
				}
				this.drowChart4(list2);
			},
			// 保护-饼图
			drowChart3(data) {
				let myChart = this.$echarts.init(document.getElementById('caseChart1'));
				var list =[
					{
						value:data.patenttort,
						name: '侵权纠纷案件'
					}]
				var total = list[0].value //+ list[1].value
				var option = {
					title:{
						text: '总计',
						top:'44%',
						left:'center',
						textStyle: {
							color: "#fff",
							fontSize:14,
							fontWeight:400,
						},
						subtext:total,
						subtextStyle: {
							color:'#fff',
							fontSize:18,
						},
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '2%',
						left: '0',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff',
						},
					},
					color: ['#178AF3', '#EDA413'], // 自定义颜色范围
					series: [{
						zlevel: 1,
						type: 'pie',
						radius: ['60%', '80%'],
						center: ["50%", "60%"],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: false,
								fontSize: '10',
								color: '#fff',
							}
						},
						labelLine: {
							show: false
						},
						data:list
					}, ]
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
			// 保护-柱状图
			drowChart4(data) {
				let myChart = this.$echarts.init(document.getElementById('caseChart2'));
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'red'
							}
						}
					},
					textStyle: {
						color: '#fff',
					},
					grid: {
						left: '0',
						right: '0',
						top: '30%',
						bottom:'0',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data:data.map(item =>item.name[0]),
						axisPointer: {
							type: 'shadow'
						},
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
						axisLine: { //X轴坐标线隐藏
							show: false,
						},
						axisTick: {
							show: false, //刻度隐藏
						}
					}],
					yAxis: [{
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel : {   //Y轴隐藏过后产生留白
							formatter: function(){
								return "";
							}
						}
					}],
					legend: {
						icon: 'diamond',
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 24, // 设置间距
						right: '0',
						top:'0%',
						data: ['纠纷案件'],
						textStyle: {
							color: '#fff',
						},
					},
					series: [{
						name: '纠纷案件',
						type: 'bar',
						barWidth: '30%',
						barGap: '10%',
						label: { //显示数值
							show: true,
							position: 'outside',
							color: '#fff'
						},
						color: [{
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [{
									offset: 0,
									color: '#0095F2'
								}, // 设置颜色渐变
								{
									offset: 1,
									color: '#00C4F2'
								}
							]
						}, ],
						data:data.map(item =>item.patenttort)
					}],
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
		}
	}
</script>

<style>
</style>
